module.exports = __webpack_public_path__ + "img/4.a69771e7.png";